import { CircularProgress, IconButton, TextField } from '@mui/material';
import React, { useState } from 'react';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

function ResourceHeaderEdit({ resource, onSaveEdit, onCancelEdit }) {
  const [editedResource, setEditedResource] = useState({ ...resource });
  const [editIsSaving, setEditIsSaving] = useState(false);

  const handleSaveEdit = async () => {
    setEditIsSaving(true);
    onSaveEdit(editedResource);
  };

  return (
    <div>
      <TextField
        type="text"
        value={editedResource.name}
        onChange={(e) => setEditedResource({ ...editedResource, name: e.target.value })}
        style={{ margin: "0 0.5em 0 0" }}
      />

      <IconButton disabled={editIsSaving} color="primary" onClick={handleSaveEdit}> { editIsSaving? <CircularProgress size="1rem"/>: <SaveOutlinedIcon/>}  </IconButton>
      <IconButton disabled={editIsSaving} color="primary" onClick={onCancelEdit}> <CancelOutlinedIcon/> </IconButton>
    </div>
  );
}

export default ResourceHeaderEdit;